import { Pipe, PipeTransform } from '@angular/core'; 
import { CertificateCategory } from '../services/certificate.service';

@Pipe({
  name: 'certificateCategory'
})
export class CertificateCategoryPipe implements PipeTransform {

  transform(value: CertificateCategory): string {
    switch (value) {
      case CertificateCategory.Certification:
        return 'Certificate';
      case CertificateCategory.Practice:
        return 'Practice';
      case CertificateCategory.Reference:
        return 'อ้างอิง';
      default:
        return value;
    }
  }
}